import { arrayToggle } from 'common/ArrayUtilities';
import { QueryParams } from 'common/urls/QueryParams';
import { map } from 'lodash';
import React, { useCallback } from 'react';
import { FoodTypeCoalesced } from 'src/gqlReactTypings.generated.d';
import { useTrackFilterChange } from '../hooks/useTrackFilterChange';
import { DISH_TYPE_TO_DISPLAY_INFO, SECTION_TEXT } from './consts';
import { Section } from './styles';
import { DisplayInfo, FilterProps } from './types';

export const DishType: React.FC<FilterProps> = ({ filters }) => {
  const { updateQueryParams, dishTypeFilters } = filters;
  const { trackFilterChange } = useTrackFilterChange({ filters });

  const handleClick = useCallback(
    (type: FoodTypeCoalesced) => {
      const updates = { [QueryParams.DISH_TYPE_FILTER]: arrayToggle(dishTypeFilters, type) };
      updateQueryParams(updates);
      trackFilterChange(updates);
    },
    [updateQueryParams, dishTypeFilters, trackFilterChange]
  );

  return (
    <Section.Container>
      <Section.Header>{SECTION_TEXT.DISH_TYPE.HEADER}</Section.Header>
      <Section.Wrapper>
        <Section.ButtonContainer>
          {map(DISH_TYPE_TO_DISPLAY_INFO, ({ Icon, title }: DisplayInfo, type: FoodTypeCoalesced) => (
            <Section.ButtonDishType
              key={type}
              selected={dishTypeFilters.includes(type)}
              onClick={() => handleClick(type)}>
              <Icon />
              <Section.ButtonText>{title}</Section.ButtonText>
            </Section.ButtonDishType>
          ))}
        </Section.ButtonContainer>
      </Section.Wrapper>
    </Section.Container>
  );
};
